(function () {
    'use strict';

    angular
        .module('app')
        .controller('LinePlanListController', lController);

    function lController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state, LinePlanService, toaster) {
        var model = this;
        model.linePlans = [];
        model.LinePlanRead = "";
        model.filterText = "";


        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 1) {
                if (userPermissionRow[1] == 1) {
                    model.LinePlanRead = true;
                }
            }
        });

        model.linePlanPredicate = ""; model.linePlanReverse = false;
        model.linePlanTableOrderby = function (predicate) {
            model.linePlanReverse = model.linePlanPredicate == predicate ? !model.linePlanReverse : false;
            model.linePlanPredicate = predicate;
        }

        if (!model.LinePlanRead) {
            $state.go('permissionDenied');
        }

        function get() {
            LinePlanService.getLinePlans().then(function (response) {
                if (response) {
                    model.linePlans = response;
                }
                else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No Line Plans Found',
                        timeout: 5000
                    });
                }

            },
            function (error, status) {
                model.linePlans = null;
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was some error while getting Line Plans. Please contact system administrator',
                    timeout: 5000
                });
            });
        };
        get();
    }
})();





